<template>
  <div class="main-container" :class="darkMode ? 'dark' : ''">
    <div class="login-container p-3" v-if="state === states.LOGIN">
      <div class="mb-2">
        <span class="login-title">
          {{ $t("pages.login.title") }}
        </span>
      </div>
      <div class="mb-5">
        <span class="login-subtitle">
          {{ $t("pages.login.subtitle") }}
        </span>
      </div>
      <form @keyup.enter="signIn()" class="mb-3">
        <div>
          <div class="login-input mb-3" :class="!valid && 'invalid'">
            <el-input
              type="text"
              class="input-inner"
              prefix-icon="el-icon-user"
              :placeholder="$t('pages.login.email')"
              v-model="form.email"
            />
          </div>
          <span class="error-label mt-1 ml-3">
            {{ $t("components.horizontalInput.invalidEmail") }}
          </span>
        </div>
        <div class="login-input mb-3" :class="!valid && 'invalid'">
          <el-input
            type="password"
            show-password
            class="input-inner"
            prefix-icon="el-icon-lock"
            :placeholder="$t('pages.login.password')"
            v-model="form.password"
          />
        </div>
      </form>
      <div class="mb-4" @click="state = states.FORGOT_PASSWORD">
        <span class="forgot-password">
          {{ $t("pages.login.forgotPassword") }}
        </span>
      </div>
      <el-button type="primary" @click="signIn">
        {{ $t("pages.login.signIn") }}
      </el-button>
      <!-- <div class="login-separator">
        <hr />
        <span>
          {{ $t("pages.login.or") }}
        </span>
        <hr />
      </div>
      <el-button type="primary" class="outline-button" @click="egovSignIn">
        {{ $t("pages.login.egovSignIn") }}
      </el-button> -->
      <div class="mt-4">
        <el-switch
          :value="darkMode"
          @change="toggleDarkMode"
          active-color="#1a84cf"
          inactive-color="#1a84cf"
          active-icon-class="el-icon-moon"
          inactive-icon-class="el-icon-sunny"
          class="theme-slider"
        />
      </div>
    </div>
    <div class="login-container p-3" v-if="state === states.FORGOT_PASSWORD">
      <div class="mb-2">
        <span class="login-title">
          {{ $t("pages.login.forgotPasswordTitle") }}
        </span>
      </div>
      <div class="mb-5">
        <span class="login-subtitle">
          {{ $t("pages.login.forgotPasswordDescription") }}
        </span>
      </div>
      <form class="mb-3" @submit.prevent="sendRecoverEmail">
        <div class="mb-5">
          <div
            class="login-input mb-2"
            :class="!validRecoverEmail && 'invalid'"
          >
            <el-input
              type="text"
              class="input-inner"
              prefix-icon="el-icon-user"
              :placeholder="$t('pages.login.email')"
              v-model="recoverEmail"
            />
          </div>
          <span class="error-label mt-1 ml-3">
            {{ $t("components.horizontalInput.invalidEmail") }}
          </span>
        </div>
      </form>
      <el-button
        type="primary"
        class="mb-3"
        :disabled="!enabledRecoverPasswordButton"
        @click="sendRecoverEmail"
        key="recover-password-button"
      >
        {{ $t("pages.login.sendButton") }}
      </el-button>
      <el-button
        type="primary"
        class="outline-button ml-0"
        @click="
          state = states.LOGIN;
          recoverEmail = undefined;
        "
      >
        {{ $t("pages.login.cancelButton") }}
      </el-button>
      <div class="mt-4">
        <el-switch
          :value="darkMode"
          @change="toggleDarkMode"
          active-color="#1a84cf"
          inactive-color="#1a84cf"
          active-icon-class="el-icon-moon"
          inactive-icon-class="el-icon-sunny"
          class="theme-slider"
        />
      </div>
    </div>
    <div class="login-container p-3" v-if="state === states.EMAIL_SENT">
      <div class="mb-2">
        <span class="login-title">
          {{ $t("pages.login.emailSentTitle") }}
        </span>
      </div>
      <div class="mb-5">
        <span class="login-subtitle">
          {{ $t("pages.login.emailSentDescription") }}
        </span>
      </div>
      <el-button type="primary" class="mt-5" @click="state = states.LOGIN">
        {{ $t("pages.login.backButton") }}
      </el-button>
      <div class="mt-4">
        <el-switch
          :value="darkMode"
          @change="toggleDarkMode"
          active-color="#1a84cf"
          inactive-color="#1a84cf"
          active-icon-class="el-icon-moon"
          inactive-icon-class="el-icon-sunny"
          class="theme-slider"
        />
      </div>
    </div>
    <UserProfileModal
      :showModal="showUserProfileModal"
      @continue="selectProfile"
      @close="cancelLogin"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { validateEmail } from '@/utils';
import UserProfileModal from '@/components/sections/login/UserProfileModal';

const STATES = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot_password',
  EMAIL_SENT: 'email_sent',
};

export default {
  components: {
    UserProfileModal,
  },
  data() {
    return {
      states: {
        LOGIN: STATES.LOGIN,
        FORGOT_PASSWORD: STATES.FORGOT_PASSWORD,
        EMAIL_SENT: STATES.EMAIL_SENT,
      },
      isLoading: false,
      state: STATES.LOGIN,
      form: {
        email: '',
        password: '',
      },
      valid: true,
      recoverEmail: undefined,
      showUserProfileModal: false,
    };
  },
  computed: {
    ...mapGetters(['getUser', 'getDarkmode']),
    darkMode() {
      return this.getDarkmode;
    },
    validRecoverEmail() {
      return (
        this.recoverEmail === undefined
        || (this.recoverEmail && validateEmail(this.recoverEmail))
      );
    },
    enabledRecoverPasswordButton() {
      return this.recoverEmail && this.validRecoverEmail;
    },
  },
  mounted() {
    /*
    if(params.access_token) {
      this.$store.dispatch('storeLoading', true);
      await this.$store.dispatch('cmdSignIn', params.access_token);
      this.$store.dispatch('storeLoading', false);

      this.$router.push({
        name: 'Home Page',
      });
    }
    */
  },
  methods: {
    async signIn() {
      try {
        this.$store.dispatch('storeLoading', true);
        await this.$store.dispatch('signIn', this.form);

        if (this.getUser.roles.length > 1) {
          this.showUserProfileModal = true;
        } else {
          await this.$store.dispatch(
            'storeUserPermissions',
            this.getUser.roles[0].profile,
          );
          this.$router.push({
            name: 'Home Page',
          });
          this.$store.dispatch('storeDistrictsGeojson');
        }
      } catch (err) {
        this.$store.dispatch('storeLoading', false);
        console.log(err);
        console.log(
          `${err.response.status} ${err.response.data.error_description}`,
        );
        const message = err.response.status === 401
          ? this.$t('pages.login.loginFailed')
          : this.$t('pages.login.loginError');
        this.$message.error(message);
      }
    },
    async selectProfile(profile) {
      await this.$store.dispatch('storeUserPermissions', profile);
      this.showUserProfileModal = false;
      this.$router.push({
        name: 'Home Page',
      });
      this.$store.dispatch('storeDistrictsGeojson');
    },
    async cancelLogin() {
      this.$store.dispatch('logout', true);
      this.showUserProfileModal = false;
      this.$message.error(this.$t('pages.login.loginCanceled'));
    },
    async egovSignIn() {
      // TODO
      this.$router.push({
        name: 'CMD Login',
      });
    },
    async sendRecoverEmail() {
      try {
        await this.$store.dispatch('sendResetPasswordEmail', this.recoverEmail);
        this.state = this.states.EMAIL_SENT;
        this.recoverEmail = undefined;
      } catch (e) {
        this.$message.error(this.$t('pages.login.emailError'));
      }
    },
    toggleDarkMode() {
      this.$store.dispatch('toggleDarkmode');
      document.documentElement.setAttribute(
        'data-theme',
        this.darkMode ? 'darkMode' : '',
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/img/login-background.png");
  background-position-x: 100%;
  background-position-y: 100%;
  background-repeat: no-repeat;
  background-size: cover;

  .login-container {
    width: 70%;
    max-width: 610px;
    text-align: center;

    .login-title {
      font-size: 36px;
      font-weight: 600;
      color: var(--primary);
    }

    .login-subtitle {
      color: white;
    }

    .login-input {
      display: flex;
      flex-direction: row;
      border-radius: 4px;
      border: 1px solid var(--input-border);

      &.invalid {
        border: 2px solid red;
        margin: -2px;

        & + .error-label {
          display: flex;
          color: red;
          font-size: 0.875rem;
        }
      }

      & + .error-label {
        display: none;
      }

      .input-inner {
        width: 100%;

        ::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: var(--border-grey);
          opacity: 1; /* Firefox */
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: var(--border-grey);
        }
        ::-ms-input-placeholder {
          /* Microsoft Edge */
          color: var(--border-grey);
        }

        ::v-deep .el-input__inner {
          border: none;
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 54px;
          padding: 0px 15px 0px 50px;
          background-color: var(--input-background);
        }

        ::v-deep .el-input__icon {
          width: 23px;
          font-size: 23px;
          margin-left: 10px;
          color: var(--primary);
          display: flex;
          align-items: center;
        }

        ::v-deep .el-input__suffix {
          padding-right: 10px;
        }
      }
    }

    .forgot-password {
      font-size: 14px;
      color: var(--primary);
      cursor: pointer;
    }

    button {
      width: 100%;
      height: 54px;
      font-size: 18px;
    }

    .login-separator {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--primary);
      text-transform: uppercase;

      hr {
        width: calc(50% - 40px);
        border-top: 1px solid var(--primary);
        margin: 2.7rem 0px;
      }
    }
  }

  &.dark {
    background-image: url("../assets/img/login-background-dark.png");
  }
}
</style>
